import React from "react";
import s from "./styles.module.scss";
import { Link } from "react-router-dom";

interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  href?: string;
  className?: string;
  white?: boolean;
  disabled?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  children,
  className = "",
  href = "",
  onClick,
  white,
  disabled,
}) => {
  const classNames = `${s.button} ${disabled ? s.disabled : ""} ${
    white ? s.white : ""
  } ${className}`;

  if (onClick)
    return (
      <button
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        disabled={disabled}
        className={classNames}
      >
        {children}
      </button>
    );

  return (
    <Link to={href} className={classNames}>
      {children}
    </Link>
  );
};

export default Button;
